import React from "react";
import { Table } from "reactstrap";
import { SimpleRow } from "../../../../layout/Table/SimpleRow";
import {
  TRANSLATED_USER_STATUSES,
} from "../../../../../config/constants";
import moment from 'moment';

function ClientDetailsTable(props) {
  const { user } = props;

  if (! user || ! user.id) {
    return <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="messages.no_data" value=""/>
      </tbody>
    </Table>
  }

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="components.pages.users.usersTable.table.id"
                 value={user.id}/>
      <SimpleRow translationKey="fields.firstName" value={user.first_name}/>
      <SimpleRow translationKey="fields.lastName" value={user.last_name}/>
      <SimpleRow translationKey="fields.email" value={user.email}/>
      <SimpleRow
        translationKey="components.pages.clients.clientsTable.table.status"
        value={TRANSLATED_USER_STATUSES[user.status]}/>
      <SimpleRow
        translationKey="components.pages.clients.clientsTable.table.created_at"
        value={moment(user.created_at).format('lll')}/>
      </tbody>
    </Table>
  );
}

export { ClientDetailsTable };
